import ApiWebCallEvo, {
    API_URL_PAYMENT_OPTIONS
} from "./calls/evo-api-call";

export default class PaymentOptionsDataProvider  {

    constructor() {}

    /***
     *
     * @param params
     * @param headers
     */
    public async getData(params = {}, headers = {}) {

        let apiCall = new ApiWebCallEvo(
            API_URL_PAYMENT_OPTIONS,
            params,
            headers
        );

        let res = await apiCall.makeCall();

        return res;
        /*if (res.status === apiCall.STATUS_OK) {
           return res.data;
       } else {
           throw new Error(res.errors[0]);
       }*/
    }

}